var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gl-root"},[_c('br'),(!_vm.params.data.number)?_c('br'):_vm._e(),(_vm.params.data.number)?_c('div',{staticClass:"gl-number"},[_vm._v(_vm._s(_vm.params.data.number))]):_vm._e(),_c('br'),(_vm.params.data.name)?_c('div',{staticClass:"gl-name"},[_vm._v(_vm._s(_vm.params.data.name))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }